import React, {Component} from 'react'
import Campaign from './Campaign'
import CampaignFrame from './CampaignFrame'

class CampaignContainer extends Component {
  render() {
    const {display} = this.props.data

    switch(display) {
      case 'left':
      case 'right':
        return <Campaign {...this.props}/>
      case 'fullscreen':
      case 'fullscreen_frame':
      default:
        return <CampaignFrame {...this.props}/>
    }
  }
}

export default CampaignContainer



// WEBPACK FOOTER //
// ./src/components/Campaign/CampaignContainer.js